import { GetLocaleDate } from '@hooks/useI18n';
import { INullableDate } from '@schemas/opsPortal/types/contractDetails';

export const getFormattedLocaleDate = (
  date: INullableDate | undefined,
  getLocaleDate: GetLocaleDate,
): string => (date ? getLocaleDate({ date }) : '');
